import SvgColor from '@/components/svg-color/SvgColor';
import { RoutesKeys } from '@/enums/routesKeys.enum';

const icon = (name: string) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

export const navConfig = [
  {
    title: 'Contests',
    path: RoutesKeys.contests,
    icon: icon('star-outline'),
  },
  {
    title: 'Matches',
    path: RoutesKeys.matches,
    icon: icon('ic_lock'),
  },
  {
    title: 'Teams',
    path: RoutesKeys.teams,
    icon: icon('people-outline'),
  },
  {
    title: 'Competitions',
    path: RoutesKeys.competitions,
    icon: icon('sport-icon'),
  },
  {
    title: 'Pages',
    path: RoutesKeys.pages,
    icon: icon('file-text-outline'),
  },
];
